import { Button, TableCell, TableRow} from '@mui/material'
import React from 'react'
import moment from 'moment'
import { displayDateFormatShort } from '../../../../constants'

const NotificationList = ({ item,  readMore,  }) => {
  return (
     <TableRow >
      {/* <TableCell sx={{
        position: 'sticky',
        left: 0,
        backgroundColor: 'inherit',
        zIndex: 8,
      }}
      >
        <Checkbox
          style={{ verticalAlign: 'super' }}
          color="primary"
          size='small'
          checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false}
          onChange={toggleBulkOps}
        />
      </TableCell>
      <TableCell
        sx={{
          position: 'sticky',
          left: 58,
          backgroundColor: 'inherit',
          zIndex: 8,
        }}>
        <ul className='list-inline flex-centered'>
        
        </ul>
      </TableCell> */}
      <TableCell sx={{ whiteSpace: "nowrap" }}>{item?.notification_type?.label || "--"}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{item?.subject ? <>{item.subject} <Button onClick={readMore} color='primary' className='delivery-header' sx={{textTransform: "none",padding:0, minWidth:0}}>Read more</Button></> : "--"}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{item?.created_at ? moment(item?.created_at).format(displayDateFormatShort) : "--"}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{item?.status===1 ? "Read" :"Unread" || "--"}</TableCell>
    </TableRow>

  )
}

export default NotificationList